import { QueryClient } from 'react-query';
import { RootState } from 'redux/types';

export const getUserToken = (store: RootState): string | null => store.login.token;
export const getQueryClient = (store: RootState): QueryClient => store.login.queryClient;
export const getKetoCalcToken = (store: RootState): string => store.login.ketoCalcToken;
